document.addEventListener('DOMContentLoaded', function() {
  if (document.querySelector('.js-load')) {
    document.querySelectorAll('.js-load').forEach(elm => {
      if (document.querySelector('.l-header').clientHeight < window.scrollY) {
        elm.classList.add('is-loaded-anchor');
      } else {
        elm.classList.add('is-loaded');
      }
    })
  }
})